import { Component, OnInit, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import { Store } from '@ngrx/store';
import swal from 'sweetalert2';
import { FollowUpStatusMasterService } from '../../../services/index';
import * as fromRoot from '../../../store/index';
import * as commonActions from '../../../store/actions/common.actions';

@Component({
    selector: 'add-edit-follow-up-status-master',
    templateUrl: './addEditFollowUpStatusMaster.component.html'
})
export class AddEditFollowUpStatusMasterComponent implements OnInit, AfterViewInit {
    public title: string;
    public teamRow: any = {};
    isLoading = false;
    searchText = '';
    statusList: any[] = [];
    filteredStatusList: any[] = [];
    selectedIds: number[] = [];

    @Output() loadEvent = new EventEmitter();

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private followUpStatusMasterService: FollowUpStatusMasterService,
        private store: Store<fromRoot.State>
    ) {}

    ngOnInit() {}

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.teamRow && this.teamRow.column) {
                this.followUpStatusMasterService.getStatusList(this.teamRow.column).then((res: any) => {
                    if (res.success) {
                        this.statusList = res.data;
                        this.filteredStatusList = res.data;
                        this.selectedIds = res.data
                            .filter((s: any) => s.is_assigned === 'Yes')
                            .map((s: any) => parseInt(s.fol_id, 10));
                    }
                });
            }
        }, 0);
    }

    onSearch() {
        const txt = this.searchText.toLowerCase().trim();
        this.filteredStatusList = txt
            ? this.statusList.filter(s => s.name.toLowerCase().includes(txt))
            : this.statusList;
    }

    isChecked(fol_id: any): boolean {
        return this.selectedIds.indexOf(parseInt(fol_id, 10)) > -1;
    }

    onToggle(fol_id: any, checked: boolean) {
        const id = parseInt(fol_id, 10);
        if (checked) {
            if (this.selectedIds.indexOf(id) === -1) { this.selectedIds.push(id); }
        } else {
            const idx = this.selectedIds.indexOf(id);
            if (idx > -1) { this.selectedIds.splice(idx, 1); }
        }
    }

    selectAll() {
        this.selectedIds = this.statusList.map((s: any) => parseInt(s.fol_id, 10));
    }

    deselectAll() {
        this.selectedIds = [];
    }

    getCheckedList(): any[] {
        return this.filteredStatusList.filter(s => this.isChecked(s.fol_id));
    }

    getUncheckedList(): any[] {
        return this.filteredStatusList.filter(s => !this.isChecked(s.fol_id));
    }

    onSave() {
        this.isLoading = true;
        const data = {
            column:  this.teamRow.column,
            fol_ids: this.selectedIds.join(',')
        };
        this.followUpStatusMasterService.save(data).then((res: any) => {
            this.isLoading = false;
            if (res.success) {
                this.store.dispatch(new commonActions.LoadAllFollowUpStatus({}));
                swal('SUCCESS', res.message, 'success');
                this.bsModalRef.hide();
                this.loadEvent.emit();
            } else {
                this.toasterService.pop({ type: 'error', title: 'ERROR', body: res.message });
            }
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/followUpStatusMaster/addEditFollowUpStatusMaster.component.ts